import type { Identifier } from "ra-core";
import { useGetManyAggregate } from "ra-core";

export const useGetSalesName = (
  id?: Identifier | null,
  options?: { enabled?: boolean },
) => {
  const enabled = id != null && (options?.enabled ?? true);
  const { data, error } = useGetManyAggregate(
    "sales",
    { ids: id != null ? [id] : [] },
    { enabled },
  );

  const sale = data?.find((item) => String(item.id) === String(id));
  return sale
    ? [sale.first_name, sale.last_name].filter(Boolean).join(" ")
    : error
      ? ""
      : "";
};
